import { PIXI } from "./tbPIXI";
import { tbImage } from "./tbImage";
import { tbLoader } from "./tbLoader";
var TBLoaderManager = function () {
    "use strict";
    this.texturesLoading = 0;
    this.names = [];
    this.paths = [];
    this.loading = [];
    this.textures = [];
    this.refs = [];
    this.json = [];
    this.images = [];
    this.allTextures = {};
    this.tbImagesCollection = [];
    this.resources = PIXI["loader"]["resources"];
    this.cache = PIXI["utils"]["TextureCache"];
    this.spineAnimations = 0;
};
TBLoaderManager.prototype.addTBImage = function (image) {
    "use strict";
    if (image && image instanceof tbImage) {
        this.tbImagesCollection.push(image);
    }
};
TBLoaderManager.prototype.createSprites = function (texture) {
    "use strict";
    console.log("TBLoaderManager::createSprites", texture.name);
    for (var i = 0; i < this.images.length; i++) {
        if (this.images[i].texture.name === texture.name) {
            this.images[i].addSprite();
        }
    }
};
TBLoaderManager.prototype.addSpine = function () {
    "use strict";
    this.spineAnimations++;
};
TBLoaderManager.prototype.loadedSpine = function () {
    "use strict";
    this.spineAnimations--;
    tbLoader.loadComplete("spine");
};
TBLoaderManager.prototype.addImage = function (context, texture) {
    "use strict";
    this.images.push(context);
};
export var tbLoaderManager = new TBLoaderManager();
